import { useState, useEffect } from 'react';

export interface CommunityInfo {
  nationality: string;
  city: string;
  community: string;
}

const COMMUNITY_KEY = 'web_community';

export function getCommunityFromStorage(): CommunityInfo | null {
  try {
    const saved = localStorage.getItem(COMMUNITY_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch {
    return null;
  }
}

export function clearCommunityFromStorage() {
  localStorage.removeItem(COMMUNITY_KEY);
}

export function saveCommunityToStorage(nationality: string, city: string): CommunityInfo {
  const info: CommunityInfo = { nationality, city, community: `${nationality} in ${city}` };
  localStorage.setItem(COMMUNITY_KEY, JSON.stringify(info));
  return info;
}

export function useCommunity() {
  const [communityInfo, setCommunityInfo] = useState<CommunityInfo | null>(() => getCommunityFromStorage());

  const saveCommunity = (nationality: string, city: string): CommunityInfo => {
    const info: CommunityInfo = { nationality, city, community: `${nationality} in ${city}` };
    setCommunityInfo(info);
    localStorage.setItem(COMMUNITY_KEY, JSON.stringify(info));
    return info;
  };

  const clearCommunity = () => {
    setCommunityInfo(null);
    localStorage.removeItem(COMMUNITY_KEY);
  };

  return { communityInfo, saveCommunity, clearCommunity };
}
